/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Lot_Size_SaveInputs */

const vi_lot_size_save = /** @type {(inputs: Lot_Size_SaveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lưu`)
};

/**

* @param {Lot_Size_SaveInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const lot_size_save = /** @type {((inputs?: Lot_Size_SaveInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Lot_Size_SaveInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_lot_size_save(inputs)
});